import { isBusinessInEverySelectedGroupSection as _ } from "../helpers/isBusinessInEverySelectedGroupSection.js";
import { useGroups as L } from "./useGroups.js";
import { useBusinessModalContext as F } from "../BusinessModalContext.js";
import { isBusinessInQuery as G } from "../helpers/isBusinessInQuery.js";
import { SelectionType as o } from "../reducer/businessModal.types.js";
const b = ({
  business: s
}) => {
  const {
    id: r,
    groups: d
  } = s, {
    sections: I = []
  } = L(), {
    preFilters: e
  } = F(), {
    selection: a
  } = e ?? {}, {
    groupIds: i = [],
    searchBusiness: u,
    searchCity: n,
    searchOrg: t
  } = a ?? {}, p = e?.selection?.type, S = e?.selectedBusinessIds ?? [], h = e?.unselectedBusinessIds ?? [], m = _({
    businessGroups: d,
    selectionGroupIds: i,
    sections: I
  }), y = G({
    name: s.name,
    city: s.city,
    code: s.code,
    zipcode: s.zipcode,
    address_full: s.address_full
  }, u), B = !n || s.city === n, f = !t || s.org_id === t, c = S?.includes(r), l = !h?.includes(r), T = i.length === 0 && !u && !n && !t, g = m && y && l && B && f || c;
  switch (p) {
    case o.UNSET:
      return c;
    case o.ALL_WITHOUT_FILTERS:
      return l;
    case o.ALL_WITH_FILTERS:
      return T ? !1 : g;
    default:
      return c;
  }
};
export {
  b as useIsBusinessSelected
};
